/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');

      if (this.terms_checkbox) {
        this.terms_checkbox.setCustomValidity(''); // Checkbox is optional

        // Save immediately whenever the checkbox state changes.
        // This covers express checkout buttons (Shop Pay, PayPal, Google Pay)
        // which bypass the regular Checkout button entirely.
        this.terms_checkbox.addEventListener('change', () => {
          const attributeValue = this.terms_checkbox.checked ? "Yes" : "No";
          this.updateCartAttribute(attributeValue);
        });
      }

      if (this.terms_checkbox && this.checkout_button) {
        this.checkout_button.addEventListener('click', (event) => {
          event.preventDefault(); // stop submission until attribute is confirmed saved

          const attributeValue = this.terms_checkbox.checked ? "Yes" : "No";

          this.updateCartAttribute(attributeValue).then(() => {
            // Attribute saved — now proceed to checkout
            const form = this.checkout_button.form;
            if (form) {
              form.requestSubmit(this.checkout_button); // preserves name="checkout"
            } else if (this.checkout_button.tagName === 'A') {
              window.location.href = this.checkout_button.href;
            } else {
              window.location.href = '/checkout';
            }
          });
        });
      }
    }

    updateCartAttribute(attributeValue) {
      return fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            "Authority to Leave": attributeValue
          }
        })
      })
        .then((response) => {
          if (!response.ok) {
            console.error('Failed to update cart attribute');
          }
          return response;
        })
        .catch((error) => {
          console.error('Error updating cart attribute:', error);
        });
    }
  }

  customElements.define('terms-checkbox', TermsCheckbox);
}